import React, { useEffect, useState } from "react";
import { Country, City } from "country-state-city";
import { Col, Input, Row } from "reactstrap";
import { FaUser } from "react-icons/fa"; // fallback icon
import { PiCaretDown } from "react-icons/pi";

const HorizontalCountry = ({
  country,
  city,
  setCountry,
  setCity,
  cityError,
  countryError,
  colSize,
  personal = false,
  countryStyle,
  cityStyle,
  countryIcon = <FaUser />,
  cityIcon = <FaUser />,
}) => {
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [cityList, setCityList] = useState([]);

  useEffect(() => {
    if (country) {
      const selected = Country.getAllCountries().find(
        (c) => c.name === country
      );
      if (selected) {
        setSelectedCountryCode(selected.isoCode);
        setCityList(City.getCitiesOfCountry(selected.isoCode));
      }
    }
  }, [country]);

  const handleCountryChange = (e) => {
    const selectedCode = e.target.value;
    const selected = Country.getAllCountries().find(
      (c) => c.isoCode === selectedCode
    );

    setSelectedCountryCode(selectedCode);
    setCountry(selected?.name || "");
    setCity("");
    setCityList(City.getCitiesOfCountry(selectedCode));
  };

  const handleCityChange = (e) => {
    setCity(e.target.value);
  };

  const defaultStyle = "icon-input-2 ";

  const selectStyle = "icon-input-2";

  return (
    <Row className="my-3">
      <Col md={colSize ?? 12}>
        <div
          className={`${personal ? defaultStyle : ""} ${
            countryError ? "border border-danger" : ""
          } ${countryStyle ?? ""}`}
        >
          {countryIcon && (
            <span className="me-2 text-muted">{countryIcon}</span>
          )}
          <Input
            type="select"
            className={selectStyle}
            value={selectedCountryCode}
            onChange={handleCountryChange}
          >
            <option value="">Select Country</option>
            {Country.getAllCountries().map((c) => (
              <option key={c.isoCode} value={c.isoCode}>
                {c.name}
              </option>
            ))}
          </Input>
          {personal && (
            <div>
              <PiCaretDown size={20} />
            </div>
          )}
        </div>
      </Col>

      <Col md={colSize ?? 12}>
        {country && (
          <div
            className={`${personal ? defaultStyle : ""} ${
              cityError ? "border border-danger" : ""
            } ${cityStyle ?? ""}`}
          >
            {cityIcon && <span className="me-2 text-muted">{cityIcon}</span>}
            <Input
              type="select"
              className={selectStyle}
              value={city}
              onChange={handleCityChange}
              disabled={!selectedCountryCode}
            >
              <option value="">Select City</option>
              {cityList.map((ct) => (
                <option key={ct.name} value={ct.name}>
                  {ct.name}
                </option>
              ))}
            </Input>
            {personal && (
              <div>
                <PiCaretDown size={20} />
              </div>
            )}
          </div>
        )}
      </Col>
    </Row>
  );
};

export default HorizontalCountry;
